import { gql } from 'src/generated/gql';

export const GET_PRESCRIPTION_TASK_QUERY = gql(`
  query GetPrescriptionTask($eventId: ID!) {
    staff_getPrescriptionTaskForEvent(eventId: $eventId) {
      id
      eventId
      status
    }
  }
`);
